import React, { useEffect, useState } from "react";
import styled from "styled-components";
import CheckBox from "components/checkbox";
import { TextArea } from "components";
import { SeparateLine } from "styles/elements/main";
import { FormGrid, FormRow, StyledLabel } from "../../../../styles/forms/main";

const Container = styled.div`
    background-color: white;
`;

const ExtraOperationalRequirements = ({ isEditable = true, onChange, workingCondition }) => {
    const [hasOthers, setHasOthers] = useState(false);

    useEffect(() => {
        if (workingCondition?.specialExtraOperationalRequirments) {
            setHasOthers(true);
        }
    }, [workingCondition]);

    const handleCheckboxChange = (event) => {
        const { checked, name } = event.target;

        onChange(checked, name);
    };

    return (
        <Container>
            <h3>Extra Operational Requirements</h3>
            <FormRow>
                <StyledLabel>Select the special requirements requested from the client</StyledLabel>
                <FormGrid>
                    <CheckBox
                        label="Goods Transfers"
                        name="goodsTransfer"
                        onChange={handleCheckboxChange}
                        value={workingCondition?.goodsTransfer}
                        borderd
                        disabled={!isEditable}
                    />
                    <CheckBox
                        label="Cash Collection"
                        name="cashCollection"
                        onChange={handleCheckboxChange}
                        value={workingCondition?.cashCollection}
                        borderd
                        disabled={!isEditable}
                    />
                    <CheckBox
                        label="Distribution"
                        name="distribution"
                        onChange={handleCheckboxChange}
                        value={workingCondition?.distribution}
                        borderd
                        disabled={!isEditable}
                    />
                    <CheckBox
                        label="Has Scales"
                        name="scales"
                        onChange={handleCheckboxChange}
                        value={workingCondition?.scales}
                        borderd
                        disabled={!isEditable}
                    />
                    <CheckBox
                        label="Has Tolls"
                        name="tolls"
                        onChange={handleCheckboxChange}
                        value={workingCondition?.tolls}
                        borderd
                        disabled={!isEditable}
                    />
                    <CheckBox
                        label="Has Returnable"
                        name="returnable"
                        onChange={handleCheckboxChange}
                        value={workingCondition?.returnable}
                        borderd
                        disabled={!isEditable}
                    />
                    <CheckBox
                        label="Has Overnights"
                        name="workingOvernight"
                        onChange={handleCheckboxChange}
                        value={workingCondition?.workingOvernight}
                        borderd
                        disabled={!isEditable}
                    />
                    <CheckBox
                        label="Working on holidays"
                        name="workingOnHolidays"
                        onChange={handleCheckboxChange}
                        value={workingCondition?.workingOnHolidays}
                        borderd
                        disabled={!isEditable}
                    />
                    <CheckBox
                        label="Others"
                        name="others"
                        onChange={(e) => {
                            setHasOthers(e.target.checked);
                            onChange("", "specialExtraOperationalRequirments");
                        }}
                        value={hasOthers}
                        borderd
                        disabled={!isEditable}
                    />
                    {hasOthers && (
                        <TextArea
                            required
                            isEditable={isEditable}
                            type="text"
                            name="specialExtraOperationalRequirments"
                            label="Others"
                            placeholder="Special Extra Operational Requirment"
                            onChange={(e) => onChange(e.target.value, e.target.name)}
                            value={workingCondition?.specialExtraOperationalRequirments}
                        />
                    )}
                </FormGrid>
            </FormRow>
            <SeparateLine />
        </Container>
    );
};

export default ExtraOperationalRequirements;
